import CreateSvgIcon from '../components/CreateSvgIcon';
import React from 'react';
import { registerIcons } from '@uifabric/styling/lib/utilities/icons';

/**
 * AddRegularDefault icon which is consistent with the one used in Figma as the
 * AddRegular icon in icons folder was not updating on mini-fluent-svg-icons package update
 */
const AddRegularDefault = CreateSvgIcon({
    Svg: props => (
        <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.8834 3.00673L12 3C12.5128 3 12.9355 3.38604 12.9933 3.88338L13 4V11H20C20.5128 11 20.9355 11.386 20.9933 11.8834L21 12C21 12.5128 20.614 12.9355 20.1166 12.9933L20 13H13V20C13 20.5128 12.614 20.9355 12.1166 20.9933L12 21C11.4872 21 11.0645 20.614 11.0067 20.1166L11 20V13H4C3.48716 13 3.06449 12.614 3.00673 12.1166L3 12C3 11.4872 3.38604 11.0645 3.88338 11.0067L4 11H11V4C11 3.48716 11.386 3.06449 11.8834 3.00673L12 3L11.8834 3.00673Z" />
        </svg>
    ),
    displayName: 'AddRegularDefault',
});

export default 'AddRegularDefault';

registerIcons({
    icons: {
        AddRegularDefault: <AddRegularDefault />,
    },
});
